export default __webpack_public_path__ + "static/About-us-access-mobile-49e5c86e9730f66ce729c14112a132b9.png";